var SearchResultsConstants = require("../../cruise/modules/_search-results.constants");
var PageView = require("../../cruise/modules/_search-results.page");
var Promotion = Backbone.Model.extend({});
var PromotionLogo = Backbone.Model.extend({});
var PromotionCollection = Backbone.Collection.extend({ model: Promotion });
var PromotionLogoCollection = Backbone.Collection.extend({
  model: PromotionLogo
});

var PromotionTag = Backbone.Model.extend({
  defaults: {
    sailing_id: "",
    id: 0,
    name: "",
    description: "",
    logo_path: ""
  }
});

// using modelId as Promotion tag comes with a built in id and collection
// overwrite models with same ID
var PromotionTagCollection = Backbone.Collection.extend({
  model: PromotionTag,
  modelId: function(attrs) {
    return `${attrs.sailing_id}:${attrs.id}`;
  }
});

var ResultsView = Backbone.View.extend({
  isInitialized: false,
  events: {
    "click [data-tab-trigger]": "toggleTab",
    "click [data-group-trigger]": "toggleGroup",
    "click [data-toggle-sailings]": "toggleSailings"
  },

  trackCompare: function(event) {
    var collection_id = $(event.currentTarget).data("compare-tray-item");

    if ($(event.currentTarget).is(":checked")) {
      this.compareIds.add(new Backbone.Model({ id: collection_id }));
    } else {
      this.compareIds.remove(this.compareIds.get(collection_id));
    }
  },

  clearCompareItems: function() {
    this.compareIds.reset();
  },

  toggleGroup: function(event) {
    var groupEl = this.$(
      '[data-group="' + $(event.currentTarget).data("group-trigger") + '"]'
    );

    this.$("[data-group].is-active")
      .not(groupEl)
      .removeClass("is-active");
    groupEl.toggleClass("is-active");
  },

  toggleTab: function(event) {
    var sailingGroupId = $(event.currentTarget).data("sailing-group");
    var sailingGroup = $('[data-group="' + sailingGroupId + '"]');

    var sailingId = $(event.currentTarget).data("tab-trigger-sailing");
    var sailingEl = this.$('[data-sailing="' + sailingId + '"]');
    //Different selectors for different HTML structure (b2b and b2c)
    var details = false;
    //checks if the sailingEl has data-details attr if not if will search its siblings that have the same sailing
    // id then search for the attr
    if (sailingEl.find("[data-details]").length) {
      details = sailingEl.find("[data-details]");
    } else {
      details = sailingEl
        .siblings('[data-sailing-details-block="' + sailingId + '"]')
        .find("[data-details]");
    }

    var collapser = details.length ? $(details).component() : false;
    var tabs = false;
    //checks if the sailingEl has data-component="tabs attr if not if will search its siblings that have the same
    // sailing id then search for the attr
    if (sailingEl.find('[data-component="tabs"]').length) {
      tabs = sailingEl.find('[data-component="tabs"]');
    } else {
      tabs = sailingEl
        .siblings('[data-sailing-details-block="' + sailingId + '"]')
        .find('[data-component="tabs"]');
    }
    tabs = tabs.length ? tabs.component() : false;
    //sets the tab according to element selected
    var tabId = $(event.currentTarget).data("tab-trigger");

    // removing global active class from group
    $("[data-group]").removeClass("details-expanded");

    if (collapser && !collapser.isOpen()) {
      this.$("[data-sailing].is-active")
        .not(sailingEl)
        .removeClass("is-active");
      sailingEl.addClass("is-active");
      sailingGroup.addClass("details-expanded");
    } else {
      sailingEl.removeClass("is-active");
      sailingGroup.removeClass("details-expanded");
    }
    // If clicked button is [data-collapser-trigger] it will toggle automatically
    if (!$(event.currentTarget).data("collapser-trigger")) {
      collapser.open();
    }
    if (tabs) {
      var productId = tabs.$el.data("bvProductId");

      if (productId) {
        // hide all review tab labels and remove all review content
        this.$('[data-tabs-tab="reviews"]').empty();

        var content = document.createElement("div");

        content.setAttribute("data-bv-show", "reviews");
        content.setAttribute("data-bv-product-id", productId);

        tabs.$el.find('[data-tabs-tab="reviews"]').append(content);
      }

      tabs.switchTo(tabId);
    }
  },

  togglePrice: function(price) {
    this.$el.removeClass("is-full is-per-day");

    switch (price) {
      case "per-day":
        this.$el.addClass("is-per-day");
        break;

      case "full":
        this.$el.addClass("is-full");
        break;
    }
  },

  toggleSailings: function(event) {
    $(event.currentTarget).toggleClass("is-active");

    this.$(
      '[data-sailings="' + $(event.currentTarget).data("toggle-sailings") + '"]'
    ).toggleClass("is-expanded");
  },

  render: function(page, view) {
    if (!page) {
      this.$el.html();
    } else {
      var Page = null;

      switch (view) {
        case SearchResultsConstants.PAGE_TYPE_SINGLE:
          Page = this.pageViews.single[page];
          break;

        case SearchResultsConstants.PAGE_TYPE_GROUPED:
          Page = this.pageViews.grouped[page];
          break;
      }

      if (Page) {
        if (this.promotionCollection.length && !Page.promotionsLoaded) {
          Page.updatePromotions(this.promotionCollection);
        }

        if (this.promotionLogoCollection.length && !Page.promotionLogosLoaded) {
          Page.updatePromotionLogos(this.promotionLogoCollection);
        }

        if (this.promotionTagCollection.length && !Page.promotionTagsLoaded) {
          Page.updatePromotionTags(
            this.promotionTagCollection,
            this.tagsTemplate
          );
        }

        Page.toggleCompareItems(this.compareIds);

        this.$el.html(Page.$el.html()).loadComponents({ autoload: true });
      }
    }

    for (var i = 0; i < this.compareIds.length; i++) {
      $(
        `[data-compare-tray-item="${this.compareIds
          .toArray()
          [i].get("collection_id")}"]`
      ).attr("checked", true);
    }

    // Belongs to the Search Results View
    // calls method to stop loading on Filters and Results
    this.$el.trigger("resultsUpdate");
  },

  clearPages: function() {
    this.pageViews = {
      single: [],
      grouped: []
    };

    // Belongs to the Search Results View
    // calls method to stop loading on Filters and Results
    this.$el.trigger("resultsUpdate");
  },

  hasPage: function(page, view) {
    switch (view) {
      case SearchResultsConstants.PAGE_TYPE_SINGLE:
        if (this.pageViews.single[page]) {
          return true;
        }
        break;

      case SearchResultsConstants.PAGE_TYPE_GROUPED:
        if (this.pageViews.grouped[page]) {
          return true;
        }
        break;
    }

    return false;
  },

  hasPromotionsLoaded: function(page, view) {
    switch (view) {
      case SearchResultsConstants.PAGE_TYPE_SINGLE:
        if (
          this.pageViews.single[page] &&
          this.pageViews.single[page].promotionsLoaded
        ) {
          return true;
        }
        break;

      case SearchResultsConstants.PAGE_TYPE_GROUPED:
        if (
          this.pageViews.grouped[page] &&
          this.pageViews.grouped[page].promotionsLoaded
        ) {
          return true;
        }
        break;
    }

    return false;
  },

  hideView: function() {
    this.$el.hide();
  },

  addSingleResultsPage: function(page, results) {
    this.pageViews.single[page] = new PageView({ el: results });
  },

  addGroupedResultsPage: function(page, results) {
    this.pageViews.grouped[page] = new PageView({ el: results });
  },

  setPromotions: function(promotions) {
    this.promotionCollection = new PromotionCollection(promotions);
  },

  setPromotionLogos: function(logos) {
    this.promotionLogoCollection = new PromotionLogoCollection(logos);
  },

  setPromotionTags: function(tags) {
    this.promotionTagCollection = new PromotionTagCollection(tags);
  },

  setLoading: function() {
    this.$el.addClass("is-loading");
  },

  stopLoading: function() {
    this.$el.removeClass("is-loading");
  },

  initialize: function(options) {
    this.pageViews = {
      single: [],
      grouped: []
    };

    this.promotionCollection = new PromotionCollection();
    this.promotionLogoCollection = new PromotionLogoCollection();
    this.promotionTagCollection = new PromotionTagCollection();
    this.compareIds = new Backbone.Collection();

    this.tagsTemplate = options.tagsTemplate;

    if ($('[data-component="compare-tray"]').length) {
      var compareTray = $('[data-component="compare-tray"]').component();
      let compareToken = compareTray.settings.token;
      if (compareToken) {
        this.compareIds.set(
          JSON.parse(window.sessionStorage.getItem("compare-" + compareToken))
        );
      }
      for (var x = 0; x < this.compareIds.length; x++) {
        let item = this.$(
          '[data-compare-tray-item="' +
            this.compareIds.toArray()[x].get("collection_id") +
            '"]'
        ).prop("checked", true);
      }
      this.listenTo(compareTray, "added", this.trackCompare.bind(this));
      this.listenTo(compareTray, "removed", this.trackCompare.bind(this));
      this.listenTo(compareTray, "cleared", this.clearCompareItems.bind(this));
    }
  }
});

module.exports = ResultsView;
